<div mat-dialog-content>
  <p>{{ 'SHARED.DOCUMENT_ATTACHMENTS.DELETE_DIALOG.CONTENT' | translate: data }}</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close="cancel" cdkFocusInitial>{{ 'SHARED.CANCEL' | translate }}</button>
  <button mat-button mat-dialog-close="delete" mat-flat-button color="primary">{{ 'SHARED.DELETE' | translate }}</button>
</div>
